import { useSelector } from 'react-redux'

import { getAuthUserId } from '../../../data/auth/authSelectors'
import { useGetCalendarTokenQuery } from '../calendarApi'

export const useCalendarRequiresAuth = () => {
  const userId = useSelector(getAuthUserId)
  const { data } = useGetCalendarTokenQuery({ providerId: userId }, { refetchOnMountOrArgChange: true })

  if (data == null) {
    return null
  }
  return data?.access_token == null
}
